import { render } from "./EndOfJob.vue?vue&type=template&id=1972ccce"
import script from "./EndOfJob.vue?vue&type=script&lang=js"
export * from "./EndOfJob.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__